<div class="col-container" *ngFor="let col of columns">
  <div *ngIf="col.id === 'packingID'">
    {{ findPackingId(material[col.id]) }}
  </div>

  <div class="col-container" *ngIf="col.id !== 'countResults' && col.id !== 'packingID' && col.id !== 'notCounted'">
    <div>
      {{ material[col.id] }}
    </div>
  </div>

  <div *ngIf="col.id === 'countResults'">
    <input type="text" class="count" [ngModel]="counted" (ngModelChange)="countedAmountChanged($event)" [attr.disabled]="isTxtDisabled()" (keypress)="numericOnly($event)" />
  </div>
  <div *ngIf="col.id === 'notCounted'">
    <app-checkbox [(ngModel)]="checked" (change)="checkBoxChanged()" [readonly]="checkBoxdisabled"></app-checkbox>
  </div>
</div>
